export default __webpack_public_path__ + "static/media/Gilroy-Light.bae9371a.otf";